import ToyotaLexusLayout from './ToyotaLexusStrategy'
import SubaruLayout from './SubaruStrategy'
import { customerId } from '@/utils/env'
import { customerHelper } from '@tweddle-se-team/common/constants'

const { CUSTOMER_IDS } = customerHelper

const brandMapper = {
  [CUSTOMER_IDS.SUBARU]: SubaruLayout,
  [CUSTOMER_IDS.TME]: ToyotaLexusLayout,
  [CUSTOMER_IDS.NORDICS]: SubaruLayout
}

const BrandPublicationViewer = ({ brand, ...props }) => {
  const BrandComponent = brandMapper[customerId] || brandMapper[customerId.TME]

  return <BrandComponent {...props} />
}

export default BrandPublicationViewer
